import { remplazarPorTildeASinTilde,filter } from "../../helpers/Buscador";
import { types } from "../../types/types";
import { ESTADOS_COTIZACIONES } from "../../utils/constants";

const initialState = {
    loading: false,
    estados: null,
    estadosSolicitud: ESTADOS_COTIZACIONES.PENDIENTE_COTIZACION.toString(),
    solicitudesPendientesCotizacion: [],
    oferente: [],
    itemsAux: [],
    oferentesAbm: [],
    dataCotizacion: null,
    cotizaciones: [],
    datoNuevoDetalleCotizacion: null,
    DocumentacionPorId: [],
    materialCompras: null,
    trackingSolicitudCotizaciones: [],
    contadorEstadosCotizaciones: [],
    trackingFacturacionCompras: [],
    idSolicitudCompras: null,
    fechaInicioCompras: null,
    fechaFinCompras: null, 
    tipoDocumentacion : null,
    mailsOferentes: null,
    oferentesPorCotizacion: []
}
export const comprasReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.estadosCotizacionesTraerStart:
            return {
                ...state,
                loading: true
            };
        case types.estadosCotizacionesTraerSuccess:
            return {
                ...state,
                estados: action.payload,
                loading: false,
            };
        case types.estadosCotizacionesTraerError:
            return {
                ...state,
                estados: null,
                loading: false
            };
        case types.updateEstadosSolicitudesCotizacion:
            return {
                ...state,
                estadosSolicitud: action.payload
            };
        case types.solicitudesCotizacionTraerStart:
            return {
                ...state,
                loading: true
            }
        case types.solicitudesCotizacionSuccess:
            return {
                ...state,
                solicitudesPendientesCotizacion: action.payload,
                loading: false
            }
        case types.solicitudesCotizacionError:
            return {
                ...state,
                solicitudesPendientesCotizacion: null,
                loading: false
            }
        case types.seleccionarOferente:
            return {
                ...state,
                oferente: action.payload,
                loading: false
            }
        case types.desSeleccionarOferente:
            return {
                ...state,
                oferente: [],
                loading: false
            }
        case types.nuevaCotizacionSuccess:
            return {
                ...state,
                dataCotizacion: action.payload,
                loading: false
            }
        case types.nuevaCotizacionError:
            return {
                ...state,
                dataCotizacion: null,
                loading: false
            }
        case types.cotizacionesSucces:
            return {
                ...state,
                cotizaciones: action.payload,
                loading: false
            }
        case types.cotizacionesError:
            return {
                ...state,
                cotizaciones: null,
                loading: false
            }
        case types.datoNuevoDetalleCotizacion:
            return {
                ...state,
                datoNuevoDetalleCotizacion: action.payload,
                loading: false
            }
        case types.oferentesAbm:
            return {
                ...state,
                oferentesAbm: [],
                loading: true
            }
        case types.oferentesAbmSuccess:
            return {
                ...state,
                oferentesAbm: action.payload,
                itemsAux: action.payload,
                loading: false
            }
        case types.oferentesAbmError:
            return {
                ...state,
                oferentesAbm: null,
                loading: false
            }
        case types.getDocumentacionXIdCabeceraCotizacion:
            return {
                ...state,
                DocumentacionPorId: action.payload,
                loading: false
            }
        case types.setMaterialCompras:
            return {
                ...state,
                materialCompras: action.payload,
                loading: false
            }
        case types.desSeleccionarMaterialCompras:
            return {
                ...state,
                materialCompras: null,
                loading: false
            }
        case types.trackingSolicitudesCotizacionSuccess:
            return {
                ...state,
                trackingSolicitudCotizaciones: action.payload,
                loading: false
            }
        case types.trackingSolicitudesCotizacionError:
            return {
                ...state,
                trackingSolicitudCotizaciones: null,
                loading: false
            }
        case types.trackingFacturacionComprasSuccess:
            return {
                ...state,
                trackingFacturacionCompras: action.payload,
                loading: false
            }
        case types.trackingFacturacionComprasError:
            return {
                ...state,
                trackingFacturacionCompras: null,
                loading: false
            }
        case types.contadoresEstadosCotizacionesSuccess:
            return {
                ...state,
                contadorEstadosCotizaciones: action.payload,
                loading: false
            }
        case types.contadoresEstadosCotizacionesError:
            return {
                ...state,
                contadorEstadosCotizaciones: null,
                loading: false
            }
        case types.seleccionarIdSolicitud:
            return {
                ...state,
                idSolicitudCompras: action.payload,
                loading: false
            }
        case types.seleccionarFechaInicio:
            return {
                ...state,
                fechaInicioCompras: action.payload,
                loading: false
            }
        case types.seleccionarFechaFin:
            return {
                ...state,
                fechaFinCompras: action.payload,
                loading: false
            }
        case types.oferentesBuscarAbm:
            var itemsResults = state.itemsAux.filter(n => filter(remplazarPorTildeASinTilde(n.razonSocial), remplazarPorTildeASinTilde(action.payload)))
            return {
                    ...state,
                    oferentesAbm: itemsResults
            }
        case types.getTiposDocumentacion :
            return{
                ...state, 
                tipoDocumentacion: action.payload
            }
        case types.mailsOferentesSuccess:
            return{
                ...state, 
                mailsOferentes: action.payload
            }
        case types.mailsOferentesClean:
            return{
                ...state, 
                mailsOferentes: null
            }
            case types.getOferentesPorCotizacionSuccess:
                return{
                    ...state, 
                    oferentesPorCotizacion: action.payload
                }
        default:
            return state;
    }
}